/**
 * @generated SignedSource<<f9339d84fc01f1115f48fc722cf9731f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutPayPalSubmit_buyer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useCheckoutIsLoggedIntoPayPal_buyer" | "usePayPalPaymentMethod_buyer">;
  readonly " $fragmentType": "CheckoutPayPalSubmit_buyer";
};
export type CheckoutPayPalSubmit_buyer$key = {
  readonly " $data"?: CheckoutPayPalSubmit_buyer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutPayPalSubmit_buyer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutPayPalSubmit_buyer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "usePayPalPaymentMethod_buyer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useCheckoutIsLoggedIntoPayPal_buyer"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "0a018ef503fe0f726b787fe9a1b5113e";

export default node;
